import type { SVGProps } from '@/types/common.types';

const ArrowNarrowRightSVG = (props: SVGProps) => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.16663 22H34.8333M34.8333 22L27.5 29.3334M34.8333 22L27.5 14.6667"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowNarrowRightSVG;
